import React, {
  FC,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { createPortal } from 'react-dom';
import cx from 'classnames';

import { IconButton } from 'components/UI';

import styles from './modal.module.scss';

interface IProps {
  id: string;
  isOpened?: boolean;
  className?: string;
  position?: 'bottom',
  closePosition?: 'bottom',
  onClose?: () => void;
}

const Modal: FC<IProps> = ({
  id,
  isOpened,
  children,
  className,
  position,
  closePosition,
  onClose,
}) => {
  const [modalsRoot, setModalsRoot] = useState<Element | null>(null);

  useEffect(() => {
    setModalsRoot(document.getElementById('portal'));
  }, []);

  /* handlers */

  const handleClose = useCallback(() => {
    if (onClose) onClose();
  }, []);

  const handleClickBackdrop = useCallback(() => {
    if (onClose) onClose();
  }, []);

  /* renderers */

  const renderModal = () => (
    <div
      id={id}
      className={cx(
        styles.container,
        { [styles.containerOpened]: isOpened },
        className,
      )}
      tabIndex={-1}
      role="dialog"
      aria-hidden={isOpened ? 'false' : 'true'}
    >
      <div
        className={cx(styles.backdrop, { [styles.backdropOpened]: isOpened })}
        tabIndex={-1}
        onClick={handleClickBackdrop}
        aria-hidden="true"
      />
      <div className={cx(styles.content, { [styles.contentBottom]: position === 'bottom' })} role="document">
        {children}

        <IconButton
          className={cx(styles.close, { [styles.closeBottom]: closePosition === 'bottom' })}
          ariaLabel="Close"
          name="cross"
          onClick={handleClose}
        />
      </div>
    </div>
  );

  if (!modalsRoot) {
    return null;
  }
  return createPortal(renderModal(), modalsRoot);
};

export default Modal;
